var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNaos = function SvgNaos(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 6.00878C10.8202 5.04313 9.42297 4.38037 7.92956 4.07796C7.62692 2.58127 6.96386 1.18136 5.99795 0C5.03494 1.18268 4.37355 2.58218 4.07063 4.07796C2.57722 4.38037 1.17996 5.04313 0 6.00878C1.17996 6.97436 2.57722 7.63711 4.07063 7.93952C4.37535 9.42947 5.03675 10.823 5.99795 12.0002C6.96469 10.8194 7.62795 9.41919 7.92956 7.92222C9.42297 7.61981 10.8202 6.95706 12.0002 5.99141",
    fill: "#00455E"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNaos);
export default ForwardRef;